/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Basic_Weird_Maggot_WalkInputs */

const fr_basic_weird_maggot_walk = /** @type {(inputs: Basic_Weird_Maggot_WalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter programme`)
};

/**

* @param {Basic_Weird_Maggot_WalkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const basic_weird_maggot_walk = /** @type {((inputs?: Basic_Weird_Maggot_WalkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Basic_Weird_Maggot_WalkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_basic_weird_maggot_walk(inputs)
});